// The 7 IQ cities (from the "One Platform. 52 Countries." section of iqcapital.io).
// `country` must match a name in COUNTRY_NAMES so the country lights up with its pin.
export interface GlobeCity {
  name: string;
  lat: number;
  lon: number;
  country: string;
}

export const GLOBE_CITIES: readonly GlobeCity[] = [
  { name: 'Los Angeles, USA', lat: 34.05, lon: -118.24, country: 'United States of America' },
  { name: 'New York, USA', lat: 40.71, lon: -74.01, country: 'United States of America' },
  { name: 'São Paulo, Brazil', lat: -23.55, lon: -46.63, country: 'Brazil' },
  { name: 'Frankfurt, Germany', lat: 50.11, lon: 8.68, country: 'Germany' },
  { name: 'Cape Town, South Africa', lat: -33.92, lon: 18.42, country: 'South Africa' },
  { name: 'Dubai, UAE', lat: 25.2, lon: 55.27, country: 'United Arab Emirates' },
  { name: 'Sydney, Australia', lat: -33.87, lon: 151.21, country: 'Australia' },
];

/** `40.71°N  74.01°W` (two spaces, rendered with white-space: pre). */
export const formatCoords = (lat: number, lon: number) =>
  `${Math.abs(lat).toFixed(2)}°${lat >= 0 ? 'N' : 'S'}  ${Math.abs(lon).toFixed(2)}°${lon >= 0 ? 'E' : 'W'}`;
